module.exports = __webpack_public_path__ + "img/TITLE.574dd0c4.png";